import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ArrangeableListInput from '../arrangeable-list-input/ArrangeableListInput';
import FilterInput from '../filter-input/FilterInput';
import './ArrangeableFilterInput.css';

export default class ArrangeableFilterInput extends Component { 
  // Grabs the values from the inputs and updates the state with the new values
  getValue = () => {
    let orderedList = this[`${this.props.id}__af-list`].getValue();
    
    if (Array.isArray(orderedList) && orderedList.length) {
      orderedList = orderedList.map((item) => {
        return { id: item.id, internalLink: item.internalLink, text: item.text }
      });
    }
    
    return orderedList;  
  }
  
  addItem = (filterValues) => {
    let newItems = [];
    
    let listValues = (this[`${this.props.id}__af-list`]) ? this[`${this.props.id}__af-list`].getValue() : [];
    
    filterValues.forEach((value) => {
      if (!listValues.find((content) => content.id === value.id)) {
        newItems.push({ id: value.id, internalLink: value.internalLink, text: value.text, order: listValues.length + newItems.length + 1 });
      }
    });

    if (newItems.length && this[`${this.props.id}__af-list`]) {
      newItems.forEach((newItem) => {
        this[`${this.props.id}__af-list`].addItem(newItem);
      });
    }
  }
  
  removeItem = (removedItem) => {
    this[`${this.props.id}__af-filter`].unselectOptions([removedItem]);
  }

  render () {  
    const label = (this.props.label) ?
      <label htmlFor={this.props.id}>
        {this.props.label}
      </label> :
      null;
    
    let filterInput = (this.props.isEditable) ?
      <FilterInput 
        id={`${this.props.id}__af-filter`}
        className="field__large"
        existingContentArray={this.props.existingContentArray}
        filterValueChange={this.addItem}
        isEditable={(!this.props.isEditable) ? false : undefined}
        options={this.props.options}
        placeholderText={this.props.placeholderText}
        ref={instance => { this[`${this.props.id}__af-filter`] = instance; }}
        showPills={false}
      /> :
      null;

    // Shows inputs when in edit mode
    let inputDisplay = 
      <span>
        {filterInput}
        <ArrangeableListInput 
          id={`${this.props.id}__af-list`}
          className="field__large"
          hasRemoveButton={true}
          isEditable={(!this.props.isEditable) ? false : undefined}
          onRemove={this.removeItem}
          options={(this.props.existingContentArray) ? 
            this.props.existingContentArray.map((item, index) => { 
              return { 
                id: item.id, 
                internalLink: item.internalLink, 
                text: item.text, 
                order: index + 1 
              } 
            }) : 
            []
          }
          ref={instance => { this[`${this.props.id}__af-list`] = instance; }}
        />
      </span>;

    return (
      <span className="arrangeable-filter-input">
        {label}
        {inputDisplay}
      </span>
    );
  }
}
    
ArrangeableFilterInput.defaultProps = {
  isEditable: true
};

ArrangeableFilterInput.propTypes = {
  existingContentArray: PropTypes.arrayOf(PropTypes.object),
  id: PropTypes.string.isRequired,
  isEditable: PropTypes.bool,
  label: PropTypes.string,
  options: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.object)
  ]).isRequired,
  placeholderText: PropTypes.string
};


// WEBPACK FOOTER //
// ./src/shared/components/presentation/arrangeable-filter-input/ArrangeableFilterInput.js